import { createApp } from 'vue';
import App from '@/App.vue';
import '@/assets/css/reset.css';
import '@/assets/css/global.css';
import { createRouter } from '@/router/index';
import { createAppSyncPlugin } from '@regional/frontend-appsync-client';
import { createAuth0, Auth0VueClientOptions } from '@auth0/auth0-vue';
import ElementPlus from 'element-plus';
import { i18n, setElementLocales } from '@/plugins/i18n';

// 各国向けデプロイでは組織ごとのサブドメインを使わないため、
// Organization IDの解決は行わずAppを初期化する
(async () => {
  // index.htmlは全国共通のため、ビルド時に確定したロケールをここで反映する
  document.documentElement.lang = i18n.global.locale.value;

  const auth0ClientOptions: Auth0VueClientOptions = {
    domain: import.meta.env.VITE_AUTH0_DOMAIN ?? '',
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID ?? '',
    authorizationParams: {
      redirect_uri: `${window.location.origin}/`,
      // Auth0 Universal Login language (ph: en / vn: vi); per-call
      // loginWithRedirect params are merged on top of these defaults
      ui_locales: import.meta.env.VITE_APP_AUTH0_LOCALE,
    },
    cookieDomain: '.spectee.com',
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
  };

  createApp(App)
    .use(createRouter())
    .use(createAuth0(auth0ClientOptions))
    // NOTE: createAppSyncPlugin must be registered AFTER createAuth0 (OIDC auth)
    .use(
      createAppSyncPlugin({
        endpoint: import.meta.env.VITE_APP_APPSYNC_GRAPHQL_ENDPOINT,
        region: import.meta.env.VITE_APP_APPSYNC_REGION,
        apolloClientOptions: {
          connectToDevTools: import.meta.env.MODE.startsWith('development'),
        },
      }),
    )
    .use(i18n)
    .use(ElementPlus, {
      locale:
        setElementLocales[i18n.global.locale.value] ?? setElementLocales.en,
    })
    .mount('#app');
})();
